import './style/index.js';

import _Calendar from './Calendar';

export type { CalendarMethods, CalendarProps } from './Calendar';
export * from './type';

export const Calendar = _Calendar;
export default Calendar;
